import PoleLocalisationPresenter from "./PoleLocalisation/PoleLocalisationPresenter";
import PoleNamePresenter from "./PoleName/PoleNamePresenter";
import PoleNumberPresenter from "./PoleNumber/PoleNumberPresneter";

export const SinglePole = {
    Name : PoleNamePresenter,
    PoleNumber : PoleNumberPresenter,
    Location : PoleLocalisationPresenter

}

export default SinglePole;